import { LitElement, css } from "lit";
//#region src/components/pd-section-page/PdSectionPage.ts
/**
* PdSectionPage - Base class for pages with section-based scroll navigation.
*
* Provides:
* - CSS scroll-margin-top for proper scroll offset (respects fixed header)
* - Automatic dispatch of pd-spa:register-sections on firstUpdated
* - Optional section actions (dispatched when section becomes visible)
*
* Usage:
* ```typescript
* @customElement("my-page")
* export class MyPage extends PdSectionPage {
*   static override styles = [
*     PdSectionPage.styles,
*     css`...`
*   ];
*
*   protected override _getSections(): SectionConfig {
*     return {
*       pageName: "my-page",
*       sections: {
*         "section1": this.shadowRoot?.getElementById("section1"),
*         "section2": this.shadowRoot?.getElementById("section2"),
*       },
*       // Optional: Actions dispatched when section becomes visible (once)
*       sectionActions: {
*         "section2": () => loadDataAction(),
*       },
*     };
*   }
* }
* ```
*/
/**
* Abstract base class for pages with section-based scroll navigation.
*
* Subclasses must implement _getSections() to provide section references.
*/
var PdSectionPage = class extends LitElement {
	static {
		this.styles = css`
    section {
      scroll-margin-top: calc(var(--pd-site-header-height, 90px) + 20px);
    }
  `;
	}
	/**
	* Dispatches pd-spa:register-sections event to register section elements.
	* Subclasses can override but should call super.firstUpdated().
	*/
	firstUpdated() {
		this.dispatchEvent(new CustomEvent("pd-spa:register-sections", {
			detail: this._getSections(),
			bubbles: true,
			composed: true
		}));
	}
};
//#endregion
export { PdSectionPage };
